/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateExtractSchemaRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  extractionSchema: components.ExtractionSchema;
};

/** @internal */
export const CreateExtractSchemaRequest$inboundSchema: z.ZodType<
  CreateExtractSchemaRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  ExtractionSchema: components.ExtractionSchema$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "ExtractionSchema": "extractionSchema",
  });
});
/** @internal */
export type CreateExtractSchemaRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  ExtractionSchema: components.ExtractionSchema$Outbound;
};

/** @internal */
export const CreateExtractSchemaRequest$outboundSchema: z.ZodType<
  CreateExtractSchemaRequest$Outbound,
  z.ZodTypeDef,
  CreateExtractSchemaRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  extractionSchema: components.ExtractionSchema$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    extractionSchema: "ExtractionSchema",
  });
});

export function createExtractSchemaRequestToJSON(
  createExtractSchemaRequest: CreateExtractSchemaRequest,
): string {
  return JSON.stringify(
    CreateExtractSchemaRequest$outboundSchema.parse(createExtractSchemaRequest),
  );
}
export function createExtractSchemaRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateExtractSchemaRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateExtractSchemaRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateExtractSchemaRequest' from JSON`,
  );
}
